<template>
  <el-dialog title="配置" :visible.sync="visible" @close="handleClose" width="600px">
    <el-form>
      <el-form-item label="已选">
        <el-tag
          class="tag"
          v-for="(menu, index) in menuChecked"
          :key="index"
          closable
          @close="delCheckedMenu(index)">
          {{menu.title}}
        </el-tag>
      </el-form-item>
    </el-form>
    <el-collapse>
      <el-collapse-item v-for="menu in menuList" :key="menu.code" :title="menu.title">
        <span class="tag pointer" v-for="(m, index) in menu.children" @click="checkMenu(m, index)" :key="index">
          <el-tag>
            {{m.title}}
          </el-tag>
        </span>
        <span v-if="menu.children.length === 0">已选择全部子路由</span>
      </el-collapse-item>
    </el-collapse>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'settingDialog',
  props: ['show', 'checkedList'],
  data () {
    return {
      visible: this.show,
      menuChecked: [],
      menuList: []
    }
  },
  methods: {
    ...mapActions(['getHomeRoutes', 'setHomeRoutes']),
    init () {
      this.menuChecked = [...this.checkedList]
      this.menuList = this.menuListFormat()
    },
    // 组建菜单
    menuListFormat () {
      const r = this.$router.options.routes[0].children
      const routeLevelTwo = r.filter(item => !!item.meta.parent)
      const menu = []
      routeLevelTwo.forEach(item => {
        const hadMenu = menu.find(m => m.title === item.meta.parent.title)
        if (!hadMenu) { // 一级菜单
          menu.push({
            title: item.meta.parent.title,
            children: []
          })
        }

        const hadChecked = this.menuChecked.find(m => m.title === item.meta.title)
        const currentIndex = menu.findIndex(m => m.title === item.meta.parent.title)
        if (!hadChecked && currentIndex !== -1) { // 没有选中且已添加过一级菜单
          menu[currentIndex].children.push({
            code: item.code,
            path: item.path,
            title: item.meta.title,
            icon: item.meta.parent.icon,
            parentTitle: item.meta.parent.title
          })
        }
      })
      return menu
    },
    // 移除已选标签
    delCheckedMenu (index) {
      const delMenu = this.menuChecked.splice(index, 1)[0]
      const menuIndex = this.menuList.findIndex(item => item.title === delMenu.parentTitle)
      if (menuIndex !== -1) {
        this.menuList[menuIndex].children.push(delMenu)
      }
    },
    checkMenu (menu, index) {
      this.menuChecked.push(menu)
      const menuIndex = this.menuList.findIndex(item => item.title === menu.parentTitle)
      this.menuList[menuIndex].children.splice(index, 1)
    },
    handleSave () {
      // 保存接口
      this.setHomeRoutes(this.menuChecked).then(() => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.getHomeRoutes()
        this.handleClose()
      })
    },
    handleClose () {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tag {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}
.pointer {
  cursor: pointer;
}
</style>
